import clsx from 'clsx';
import React from 'react';
import { GroupFilter } from 'types/groupService';
import { createStyles } from './styles';

export interface FilterCardPropsType {
  activeFilter: GroupFilter;
  ownFilter: GroupFilter;
  title: string;
  quantity?: string;
  styles?: string;
  onSetFilter: (ownFilter: GroupFilter) => void;
}

const FilterCard = ({
  title,
  activeFilter,
  ownFilter,
  quantity,
  styles,
  onSetFilter,
}: FilterCardPropsType): JSX.Element => {
  const classes = createStyles();

  const keyPressHandler = (e: React.KeyboardEvent<HTMLElement> | KeyboardEvent): void => {
    if (e.keyCode === 13) {
      onSetFilter(ownFilter);
    }
  };
  return (
    <li
      role="menuitem"
      tabIndex={0}
      className={clsx(
        classes.filterCard,
        classes[`filterCard_${ownFilter}`],
        activeFilter === ownFilter && classes[`filterCardActive_${ownFilter}`],
        styles || '',
      )}
      onClick={(): void => onSetFilter(ownFilter)}
      onKeyDown={keyPressHandler}
    >
      <h6 className={classes.filterCardTitle}>{title}</h6>
      {quantity && <p className={classes.filterCardQuantity}>{quantity}</p>}
    </li>
  );
};

export default FilterCard;
